
import { Col, Row } from "react-bootstrap";

// import Tile from '../../../../common/Tile'

export interface FurtherInformationsProps {
  title: string;
  value: string;
  contact?: string;
}

const FurtherInformations: React.FC<FurtherInformationsProps> = ({
  title,
  value,
  contact,
}) => {
  return (
    <>
      <div className="rounded-4 bg-white solid border py-1 h-100 border-1">
        <Row className="furtherInformationsTitle px-4 pt-2">
          <Col>{title}</Col>
        </Row>

        <Row className="pt-2 pt-lg-4">
          <Col xs={12} className="furtherInformationsValue">
            {value}
          </Col>
        </Row>

        <Row className="mb-0 pt-lg-3">
          <Col xs={12} className="text-center">
            {contact ? (
              <a href={`mailto:${contact}`} className="furtherInformationsLast">
                Contacter
              </a>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FurtherInformations;
